import isString from './isString';

/**
 * Inserts space after third number to format number as a Swedish postal code
 */
export default function formatPostalCode(value: string | number): string;
export default function formatPostalCode(value: unknown): unknown;
export default function formatPostalCode(value: string | number | unknown) {
  const s = isString(value)
    ? value
    : Number.isInteger(value)
      ? (value as number).toString()
      : undefined;

  return s == null ? value : s.replace(/^(\d{3})(\d{2})/, '$1 $2');
}
